import { ArrowUpRight, Phone, Settings2 } from "lucide-react";
import BrandMark from "@/components/BrandMark";

export default function SiteHeader({ lang, setLang, phone }) {
  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner">
        <a className="brand-link" href="#top" data-testid="brand-home-link" aria-label="Glow Cleaning Co. home"><BrandMark /></a>
        <nav className="desktop-nav" aria-label="Primary navigation">
          <a href="#services" data-testid="nav-services-link">{lang === "en" ? "Services" : "Servicios"}</a>
          <a href="#standard" data-testid="nav-manifesto-link">{lang === "en" ? "Our standard" : "Nuestro estándar"}</a>
          <a href="#areas" data-testid="nav-areas-link">{lang === "en" ? "Maryland" : "Maryland"}</a>
          <a href="#contact" data-testid="nav-contact-link">{lang === "en" ? "Contact" : "Contacto"}</a>
        </nav>
        <div className="header-actions">
          <div className="language-toggle" aria-label="Language selector">
            <button className={lang === "en" ? "active" : ""} onClick={() => setLang("en")} data-testid="language-toggle-en-button">EN</button>
            <button className={lang === "es" ? "active" : ""} onClick={() => setLang("es")} data-testid="language-toggle-es-button">ES</button>
          </div>
          <a className="header-call" href={`tel:${phone.replace(/\D/g, "")}`} data-testid="nav-call-direct-button"><Phone size={15} aria-hidden="true" /><span>{phone}</span></a>
          <a className="header-admin" href="/admin" data-testid="admin-portal-trigger-button"><Settings2 size={15} aria-hidden="true" /><span>Admin</span></a>
          <a className="header-cta" href="#contact" data-testid="nav-contact-button"><span>{lang === "en" ? "Get in touch" : "Contáctanos"}</span><ArrowUpRight size={16} aria-hidden="true" /></a>
        </div>
      </div>
    </header>
  );
}
